import { useEffect } from 'react';
/** Bootstrap tooltips must be initialised manually for elements rendered after the page's initial DOMContentLoaded-triggered init in _Layout.cshtml. */
export function useBootstrapTooltips(containerRef, deps) {
    useEffect(() => {
        if (!window.bootstrap || !containerRef.current) {
            return;
        }
        const elements = containerRef.current.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltips = Array.from(elements).map(element => new window.bootstrap.Tooltip(element, { placement: 'top', trigger: 'hover', fallbackPlacements: [] }));
        return () => {
            tooltips.forEach(tooltip => tooltip.dispose());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
